<template>
  <div class="expandable-section" :class="{ opened }">
    <a href="#" class="title" @click="toggle">
      <slot name="title" />
      <svgicon name="chevron-down" :alt="$t('Toggle')" />
    </a>
    <slot v-if="opened" name="content" />
  </div>
</template>
<script>
import '@/lib/icons/chevron-down';

export default {
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
};

</script>

<style lang="scss" scoped>


  .expandable-section.opened {
    .title .svg-icon {
      transform: rotate(180deg);
    }
  }

  .title {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 0.5rem;
    text-decoration: none;
    color: $black;

    .svg-icon {
      margin-left: 0.5rem;
      color: $primary-500;
    }
  }

</style>
